import { useTranslation } from 'react-i18next';
import { cn } from '@anytag/shared-utils';
import { Button, ButtonProps } from './button';

export type UploadButtonProps = ButtonProps;

export const UploadButton = ({ loading, className, ...restProps }: UploadButtonProps) => {
  const { t } = useTranslation();

  return (
    <Button
      className={cn('min-w-33.25', className)}
      title={t('Button.CSV Upload')}
      prefixIcon={{ icon: 'upload', size: '14px' }}
      {...restProps}
    />
  );
};
